import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "canvas-studio-container",
  ref: "containerRef"
}
const _hoisted_2 = { class: "canvas-toolbar" }
const _hoisted_3 = { class: "toolbar-left" }
const _hoisted_4 = { class: "custom-file-upload" }
const _hoisted_5 = {
  key: 0,
  class: "toolbar-right"
}
const _hoisted_6 = { class: "zoom-indicator" }
const _hoisted_7 = {
  key: 0,
  class: "empty-canvas-guide"
}
const _hoisted_8 = { class: "guide-circle" }
const _hoisted_9 = {
  key: 1,
  class: "canvas-hints"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Upload = _resolveComponent("Upload")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_RefreshRight = _resolveComponent("RefreshRight")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_ZoomIn = _resolveComponent("ZoomIn")!
  const _component_ZoomOut = _resolveComponent("ZoomOut")!
  const _component_MapLocation = _resolveComponent("MapLocation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _createElementVNode("input", {
            type: "file",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadBaseImage && _ctx.uploadBaseImage(...args))),
            accept: "image/*",
            class: "hidden-file-input"
          }, null, 32),
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Upload)
            ]),
            _: 1
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.hasImage ? "更换底图" : "上传手绘底图"), 1)
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "toolbar-tip" }, "支持 2:1 比例手绘地图 (JPG/PNG)", -1))
      ]),
      (_ctx.hasImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, " 缩放: " + _toDisplayString(Math.round(_ctx.imgScale * 100)) + "% ", 1),
            _createVNode(_component_el_tooltip, {
              content: "重置居中",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "tool-btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetTransform && _ctx.resetTransform(...args)))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_RefreshRight)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tooltip, {
              content: "放大",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "tool-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomStep(0.1)))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ZoomIn)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tooltip, {
              content: "缩小",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "tool-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoomStep(-0.1)))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ZoomOut)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["canvas-viewport", { 'is-grabbing': _ctx.isDragging, 'has-img': _ctx.hasImage }])
    }, [
      _createElementVNode("canvas", {
        ref: "canvasRef",
        class: "main-canvas",
        onMousedown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startDragging && _ctx.startDragging(...args))),
        onMousemove: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.dragging && _ctx.dragging(...args))),
        onMouseup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.stopDragging && _ctx.stopDragging(...args))),
        onMouseleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.stopDragging && _ctx.stopDragging(...args))),
        onWheel: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleWheel && _ctx.handleWheel(...args)))
      }, null, 544),
      (!_ctx.hasImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_MapLocation)
                ]),
                _: 1
              })
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "guide-title" }, "暂未加载手绘地图底图", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "guide-desc" }, [
              _createTextVNode(" 点击左上方按钮上传园区或景区手绘平面图"),
              _createElementVNode("br"),
              _createTextVNode(" 上传后支持鼠标滚轮平滑缩放与按住画布拖拽移动 ")
            ], -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("span", null, "滚轮缩放 · 拖拽平移", -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 2)
  ], 512))
}